declare namespace $ {

	type $shm_list_head__title_shm_dashboard_admin_monitoring_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__filter_shm_dashboard_admin_monitoring_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__add_content_shm_dashboard_admin_monitoring_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_head['add_content'] >
	>
	type $shm_list_head__Close_shm_dashboard_admin_monitoring_4 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Close'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_dashboard_admin_monitoring_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_monitoring_7 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['day_prev'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_dashboard_admin_monitoring_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_date__value_shm_dashboard_admin_monitoring_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['day'] >
		,
		ReturnType< $mol_date['value'] >
	>
	type $mol_date__trigger_content_shm_dashboard_admin_monitoring_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_date['trigger_content'] >
	>
	type $mol_button_minor__hint_shm_dashboard_admin_monitoring_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_dashboard_admin_monitoring_13 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['day_next_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_monitoring_14 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['day_next'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_dashboard_admin_monitoring_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_monitoring_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_monitoring_17 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['day_latest'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_monitoring_19 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_monitoring_20 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['enabled_count'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_monitoring_21 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_monitoring_22 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['running_count'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__style_shm_dashboard_admin_monitoring_23 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_dashboard_admin_monitoring['running_color'] >,
		})  & ReturnType< $shm_ba_summary_card['style'] >
		,
		ReturnType< $shm_ba_summary_card['style'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_monitoring_24 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_monitoring_25 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['completed_count'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__style_shm_dashboard_admin_monitoring_26 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_dashboard_admin_monitoring['completed_color'] >,
		})  & ReturnType< $shm_ba_summary_card['style'] >
		,
		ReturnType< $shm_ba_summary_card['style'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_monitoring_27 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_monitoring_28 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['error_count'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__style_shm_dashboard_admin_monitoring_29 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_dashboard_admin_monitoring['error_count_color'] >,
		})  & ReturnType< $shm_ba_summary_card['style'] >
		,
		ReturnType< $shm_ba_summary_card['style'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_monitoring_30 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_monitoring_31 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['outdated_count'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__style_shm_dashboard_admin_monitoring_32 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_dashboard_admin_monitoring['outdated_color'] >,
		})  & ReturnType< $shm_ba_summary_card['style'] >
		,
		ReturnType< $shm_ba_summary_card['style'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_dashboard_admin_monitoring_35 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_dashboard_admin_monitoring['problems_color'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_list__rows_shm_dashboard_admin_monitoring_36 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['problem_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_dashboard_admin_monitoring_48 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['task_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_dashboard_admin_monitoring_57 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_dashboard_admin_monitoring['state_color'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_dashboard_admin_monitoring_60 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['error_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_dashboard_admin_monitoring_61 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_dashboard_admin_monitoring['error_color'] >,
		})  & ReturnType< $mol_text['style'] >
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_button_minor__title_shm_dashboard_admin_monitoring_62 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['problem_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_monitoring_63 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_monitoring['problem_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_dashboard_admin_monitoring_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_admin_monitoring extends $mol_page {
		filter( next?: string ): string
		Head( ): $shm_list_head
		Day_title( ): $mol_view
		day_prev( next?: any ): any
		Day_prev_icon( ): $mol_icon_chevron_left
		Day_prev( ): $mol_button_minor
		day( next?: string ): string
		day_display( ): string
		Day_value( ): $mol_view
		Day( ): $mol_date
		day_next_enabled( ): boolean
		day_next( next?: any ): any
		Day_next_icon( ): $mol_icon_chevron_right
		Day_next( ): $mol_button_minor
		day_latest( next?: any ): any
		Day_latest( ): $mol_button_minor
		Controls( ): $mol_view
		enabled_count( ): string
		Enabled( ): $shm_ba_summary_card
		running_count( ): string
		running_color( ): string
		Running( ): $shm_ba_summary_card
		completed_count( ): string
		completed_color( ): string
		Completed( ): $shm_ba_summary_card
		error_count( ): string
		error_count_color( ): string
		Errors( ): $shm_ba_summary_card
		outdated_count( ): string
		outdated_color( ): string
		Outdated( ): $shm_ba_summary_card
		Summary( ): $mol_view
		problems_title( ): string
		problems_color( ): string
		Problems_title( ): $mol_view
		problem_rows( ): readonly(any)[]
		Problem_rows( ): $mol_list
		Problems( ): $mol_view
		Head_dashboard( ): $mol_view
		Head_file( ): $mol_view
		Head_client( ): $mol_view
		Head_period( ): $mol_view
		Head_ba_id( ): $mol_view
		Head_state( ): $mol_view
		Head_dates( ): $mol_view
		Head_time( ): $mol_view
		Head_error( ): $mol_view
		Table_head( ): $mol_view
		task_rows( ): readonly(any)[]
		Rows( ): $mol_list
		Table( ): $mol_view
		empty_text( ): string
		Empty( ): $mol_view
		problem_title( id: any): string
		problem_open( id: any, next?: any ): any
		dashboard_title( id: any): string
		Dashboard_cell( id: any): $mol_view
		file_title( id: any): string
		File( id: any): $mol_view
		client_title( id: any): string
		Client( id: any): $mol_view
		period_title( id: any): string
		Period( id: any): $mol_view
		ba_id_title( id: any): string
		Ba_id( id: any): $mol_view
		state_title( id: any): string
		state_color( id: any): string
		State( id: any): $mol_view
		dates_text( id: any): string
		Dates( id: any): $mol_view
		time_text( id: any): string
		Time( id: any): $mol_view
		error_text( id: any): string
		error_color( id: any): string
		Error( id: any): $mol_text
		title( ): string
		head( ): readonly(any)[]
		body( ): readonly(any)[]
		Problem( id: any): $mol_button_minor
		Row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=monitoring.view.tree.d.ts.map